import React from "react";
import { Button } from "react-bootstrap";

const Pager = ({ page, loading, onPage }) => {
  if (!page || Number(page.last_page || 1) <= 1) return null;
  return (
    <div className="cw-pager">
      <Button
        disabled={Number(page.current_page || 1) <= 1 || loading}
        onClick={() => onPage(Number(page.current_page) - 1)}
      >
        Previous
      </Button>
      <span>Page {page.current_page || 1} of {page.last_page || 1}</span>
      <Button
        disabled={Number(page.current_page || 1) >= Number(page.last_page || 1) || loading}
        onClick={() => onPage(Number(page.current_page) + 1)}
      >
        Next
      </Button>
    </div>
  );
};

export default Pager;
